import type { Baby } from './types';

export const baby: Baby = {
  name: 'Lena',
  ageWeeks: 14,
  ageMonths: 3.2,
  initials: 'LV',
  dob: 'Feb 14, 2026',
};

export const babies: Baby[] = [
  { id: 'lena', name: 'Lena', initials: 'LV', dob: 'Feb 14, 2026', ageWeeks: 14, ageMonths: 3.2, current: true, preset: 'girl' },
  { id: 'noah', name: 'Noah', initials: 'NV', dob: 'Aug 03, 2024', ageWeeks: 95, ageMonths: 21.7, current: false, preset: 'boy' },
];
